import React, { Component } from 'react'
import {Link,NavLink, Switch, Route} from 'react-router-dom';
import './PersonalComponent.css';
import InvalidPath from '../NotFound';
import TestComponent from '../MyLearningComponent/TestComponent';
import AddPracticeDeatil from '../MyLearningComponent/AddPracticeDetail';

export class PersonalComponent extends Component {
    render() {
        return (
            <div className="PersonalCompo-Row">
            <div className="PersonalComponentSideBarNav">
             <Link to={"/Personal"}>Practice</Link><br/>
             <NavLink to={"/Personal/AddPractice"}>AdditionalPractice</NavLink><br/>
            </div>
            <div className="PersonalCompoMainContentArea">
             <Switch>
             <Route exact path="/Personal" component={TestComponent} ></Route>
             <Route path="/Personal/Practice" component={TestComponent} ></Route>
             <Route path="/Personal/AddPractice" component={AddPracticeDeatil}></Route>             
             <Route component={InvalidPath}></Route>
             </Switch>         
            </div>
            </div>
        )
    }
}

export default PersonalComponent
